module.exports = __webpack_public_path__ + "static/img/higVacuum-p.9cc0a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/higVacuum-p.png
// module id = sBle
// module chunks = 1